(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jwellart-album-personnalisation"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-jw-album]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const words = JSON.parse(root.querySelector('[data-jw-upload-words]').textContent);
    const finishLabels = JSON.parse(root.querySelector('[data-jw-finish-labels]').textContent);
    const form = root.closest('form[action*="/cart/add"]');
    if (!form) { root.querySelector('[data-jw-error]').textContent = words.form_error; root.querySelector('[data-jw-error]').hidden = false; return; }
    const variants = JSON.parse(root.querySelector('[data-jw-variants]').textContent);
    const slots = [...root.querySelectorAll('[data-jw-slot]')];
    const error = root.querySelector('[data-jw-error]');
    const pending = new Set();
    let current = null;

    const showError = (message) => { error.textContent = message; error.hidden = !message; };
    const variantId = () => form.querySelector('[name="id"]')?.value || new URLSearchParams(location.search).get('variant');
    const sync = () => {
      const variant = variants.find((item) => String(item.id) === String(variantId())) || variants[0];
      if (!variant || variant.id === current?.id) return;
      current = variant;
      const count = Number.parseInt(variant.option2, 10) === 16 ? 16 : 8;
      root.querySelector('[data-jw-selection]').textContent = words.selection.replace('{finish}', finishLabels[variant.option1] || variant.option1).replace('{count}', String(count));
      slots.forEach((slot, index) => {
        const active = index < count;
        slot.hidden = !active;
        slot.querySelector('[data-jw-total]').textContent = String(count);
        const input = slot.querySelector('input');
        input.disabled = !active;
        input.required = active;
      });
      updateCount();
      showError('');
    };
    const updateCount = () => {
      const active = slots.filter((slot) => !slot.hidden);
      const filled = active.filter((slot) => slot.querySelector('input').files.length).length;
      root.querySelector('[data-jw-count]').textContent = words.count.replace('{filled}', String(filled)).replace('{total}', String(active.length));
    };
    const prepareImage = async (file) => {
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) throw Error(words.file_error);
      const bitmap = await createImageBitmap(file);
      const scale = Math.min(1, 1400 / Math.max(bitmap.width, bitmap.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(bitmap.width * scale);
      canvas.height = Math.round(bitmap.height * scale);
      const context = canvas.getContext('2d');
      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      bitmap.close();
      let blob = null;
      for (const quality of [.84, .7, .55]) {
        blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
        if (blob && blob.size <= 700000) break;
      }
      if (!blob || blob.size > 700000) throw Error(words.large_error);
      return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
    };
    slots.forEach((slot) => {
      const input = slot.querySelector('input');
      input.addEventListener('change', () => {
        const original = input.files[0];
        if (!original) { updateCount(); return; }
        const task = prepareImage(original).then((prepared) => {
          const files = new DataTransfer();
          files.items.add(prepared);
          input.files = files.files;
          const preview = slot.querySelector('img');
          if (slot.dataset.previewUrl) URL.revokeObjectURL(slot.dataset.previewUrl);
          slot.dataset.previewUrl = URL.createObjectURL(prepared);
          preview.src = slot.dataset.previewUrl;
          preview.hidden = false;
          slot.dataset.filled = 'true';
          slot.querySelector('[data-jw-filename]').textContent = prepared.name;
          showError('');
        }).catch((cause) => {
          input.value = '';
          showError(`Photo ${slot.dataset.index} : ${cause.message}`);
        }).finally(() => { pending.delete(task); updateCount(); });
        pending.add(task);
      });
    });
    form.addEventListener('change', () => { sync(); setTimeout(sync, 0); setTimeout(sync, 100); }, true);
    document.addEventListener('variant:change', sync);
    document.addEventListener('product:variant-change', sync);
    window.addEventListener('popstate', sync);
    const observer = new MutationObserver(sync);
    const idInput = form.querySelector('[name="id"]');
    if (idInput) observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    form.addEventListener('submit', async (event) => {
      if (event.defaultPrevented) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      await Promise.allSettled([...pending]);
      sync();
      const missing = slots.find((slot) => !slot.hidden && !slot.querySelector('input').files.length);
      if (missing) { showError(words.missing.replace('{number}', missing.dataset.index)); missing.querySelector('input').focus(); return; }
      if (!form.reportValidity()) return;
      showError('');
      HTMLFormElement.prototype.submit.call(form);
    }, true);
    sync();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jwellart-cadre-personnalisation"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-jw-cadre]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const words = JSON.parse(root.querySelector('[data-jw-upload-words]').textContent);
    const finishLabels = JSON.parse(root.querySelector('[data-jw-finish-labels]').textContent);
    const form = root.closest('form[action*="/cart/add"]');
    if (!form) { root.querySelector('[data-jw-error]').textContent = words.form_error; root.querySelector('[data-jw-error]').hidden = false; return; }
    const variants = JSON.parse(root.querySelector('[data-jw-variants]').textContent);
    const slots = [...root.querySelectorAll('[data-jw-slot]')];
    const error = root.querySelector('[data-jw-error]');
    const pending = new Set();
    let current = null;

    const showError = (message) => { error.textContent = message; error.hidden = !message; };
    const variantId = () => form.querySelector('[name="id"]')?.value || new URLSearchParams(location.search).get('variant');
    const sync = () => {
      const variant = variants.find((item) => String(item.id) === String(variantId())) || variants[0];
      if (!variant || variant.id === current?.id) return;
      current = variant;
      root.querySelector('[data-jw-selection]').textContent = words.selection.replace('{finish}', finishLabels[variant.option1] || variant.option1).replace('{count}', '8');
      slots.forEach((slot) => { slot.querySelector('input').required = true; });
      updateCount();
      showError('');
    };
    const updateCount = () => {
      const active = slots.filter((slot) => !slot.hidden);
      const filled = active.filter((slot) => slot.querySelector('input').files.length).length;
      root.querySelector('[data-jw-count]').textContent = words.count.replace('{filled}', String(filled)).replace('{total}', String(active.length));
    };
    const prepareImage = async (file) => {
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) throw Error(words.file_error);
      const bitmap = await createImageBitmap(file);
      const scale = Math.min(1, 1400 / Math.max(bitmap.width, bitmap.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(bitmap.width * scale);
      canvas.height = Math.round(bitmap.height * scale);
      const context = canvas.getContext('2d');
      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      bitmap.close();
      let blob = null;
      for (const quality of [.84, .7, .55]) {
        blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
        if (blob && blob.size <= 700000) break;
      }
      if (!blob || blob.size > 700000) throw Error(words.large_error);
      return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
    };
    slots.forEach((slot) => {
      const input = slot.querySelector('input');
      input.addEventListener('change', () => {
        const original = input.files[0];
        if (!original) { updateCount(); return; }
        const task = prepareImage(original).then((prepared) => {
          const files = new DataTransfer();
          files.items.add(prepared);
          input.files = files.files;
          const preview = slot.querySelector('img');
          if (slot.dataset.previewUrl) URL.revokeObjectURL(slot.dataset.previewUrl);
          slot.dataset.previewUrl = URL.createObjectURL(prepared);
          preview.src = slot.dataset.previewUrl;
          preview.hidden = false;
          slot.dataset.filled = 'true';
          slot.querySelector('[data-jw-filename]').textContent = prepared.name;
          showError('');
        }).catch((cause) => {
          input.value = '';
          showError(`Photo ${slot.dataset.index} : ${cause.message}`);
        }).finally(() => { pending.delete(task); updateCount(); });
        pending.add(task);
      });
    });
    form.addEventListener('change', () => { sync(); setTimeout(sync, 0); setTimeout(sync, 100); }, true);
    document.addEventListener('variant:change', sync);
    document.addEventListener('product:variant-change', sync);
    window.addEventListener('popstate', sync);
    const observer = new MutationObserver(sync);
    const idInput = form.querySelector('[name="id"]');
    if (idInput) observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    form.addEventListener('submit', async (event) => {
      if (event.defaultPrevented) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      await Promise.allSettled([...pending]);
      sync();
      const missing = slots.find((slot) => !slot.hidden && !slot.querySelector('input').files.length);
      if (missing) { showError(words.missing.replace('{number}', missing.dataset.index)); missing.querySelector('input').focus(); return; }
      if (!form.reportValidity()) return;
      showError('');
      HTMLFormElement.prototype.submit.call(form);
    }, true);
    sync();
  });
  } catch(e) { console.error(e); }
})();

})();
